import { render } from "./page7.vue?vue&type=template&id=2e60c2fd&scoped=true"
import script from "./page7.vue?vue&type=script&lang=js"
export * from "./page7.vue?vue&type=script&lang=js"

import "./page7.vue?vue&type=style&index=0&id=2e60c2fd&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e60c2fd"]])

export default __exports__